<template>
    <div class="modal resume-modal">
        <div
            class="resume-confirmation"
        >
            <p>Do you want to resume Fusebox Pro Subscription?</p>
            <div class="resume-controls flex">
                <base-submit-button
                    class="btn"
                    :loading="formProcessing"
                    @click="resumeSubscription"
                >
                    Yes, resume
                </base-submit-button>
                <button
                    class="btn btn-secondary"
                    @click="closeModal"
                >
                    No
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import apiCall from '@/utils/apiCall';
import unsuspendUser from '@/utils/user/unsuspendUser';
import toasts from '@/mixins/toasts';
import { mapActions, mapMutations, mapState } from 'vuex';
import modal from '@/mixins/modal';

export default {
    mixins: [toasts, modal],
    props: {
        subscriptionId: {
            type: Number,
            default: null,
        },
    },

    /**
     * Componen data
     *
     * @returns  {object}  Component data
     */
    data() {
        return {
            confirmationOpen: false,
            formProcessing: false,
        };
    },

    computed: mapState(['user']),

    methods: {
        ...mapActions(['updateUser', 'loadUpcomingInvoice', 'loadUserSubscription']),
        ...mapMutations(['changeUIState']),

        /**
         * Handles confirmation dialog
         *
         */
        closeModal() {
            this.changeUIState({ isResumeSubscriptionModalVisible: false });
        },

        /**
         * Resumes subscription
         *
         */
        async resumeSubscription() {
            const { status } = await apiCall(this, 'post', `/api/billing/subscriptions/${this.subscriptionId}`);

            if (200 === status) {
                this.formProcessing = true;

                const unsuspend = await unsuspendUser(this);
                const updateUser = this.updateUser();
                const upcomingInvoice = this.loadUpcomingInvoice();
                const subscription = this.loadUserSubscription({ force: true });

                Promise.all([unsuspend, updateUser, upcomingInvoice, subscription])
                    .then(() => {
                        this.formProcessing = false;

                        this.closeModal();

                        this.toastSuccess({
                            message: {
                                title: 'Your subscription has been resumed!',
                            },
                        });
                    });
            } else {
                this.closeModal();

                this.toastError({
                    message: {
                        title: 'An error occured, we couldn\'t update your payment method. Please contact us, or try again later',
                    },
                });
            }
        },

        /**
         * Unsuspends user subscription
         */
        async unsuspendUser() {
            if (this.user.suspended_at) {
                const { status } = await apiCall(this, 'post', '/api/user/unsuspend');

                return (200 === status);
            } else {
                return true;
            }
        },
    },
};
</script>
